export var clientHeaderAUMMapper = function (data) {
    var result = {};
    //console.log("client", data);
    if (data) {
        result.totalAUM = data.totalaum;
        result.totalInvestmentValue = data.totalinvestmentvalue;
        result.gainLoss = data.gainloss;
        result.gainLossPer = data.gainlossper;
        result.OpenTask = data.opentask;
        result.ProductList = data.productlist.map(function (productList) {
            return {
                product: productList.product,
                investmentValue: productList.investmntvalue,
                pid: productList.pid,
            };
        });
        result.product = data.product;
        result.pname = data.pname;
        result.marketValue = data.marketvalue;
        result.pid = data.pid;
    }
    return result;
};
